export default __webpack_public_path__ + "static/media/bewerber-third-img.31269992.png";